<template>
  <div style="min-height: 200px">
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 门店库存 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="门店仓库">
          <customer-store-select
            :defaultFirst="true"
            style="width: 206px"
            v-model="storeGuid"
            placeholder="门店"
          />
        </el-form-item>
        <el-form-item label="商品类型">
          <el-select
            v-model="formInline.goodsType"
            @change="queryClick"
            style="width: 120px"
            placeholder="商品类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="普通商品" value="default"></el-option>
            <el-option label="兽用药品" value="veterinary"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="库存状态">
          <el-select
            v-model="formInline.optWarning"
            @change="queryClick"
            style="width: 120px"
            placeholder="记录类型"
          >
            <el-option label="全部类型" value=""></el-option>
            <el-option label="预警中的" value="1"></el-option>
            <el-option label="已售罄的" value="2"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="最小库存">
          <el-input
            type="number"
            style="width: 120px"
            v-model="formInline.minStock"
            @change="queryClick"
            placeholder="最小库存"
          ></el-input>
        </el-form-item>
        <el-form-item label="最大库存">
          <el-input
            type="number"
            style="width: 120px"
            v-model="formInline.maxStock"
            @change="queryClick"
            placeholder="最大库存"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效天数">
          <el-input
            type="number"
            style="width: 120px"
            v-model="formInline.filterEffectiveDays"
            @change="queryClick"
            placeholder="有效天数"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序方式">
          <el-select
            v-model="orderByDescOrAsc"
            @change="queryClick"
            style="width: 120px"
            placeholder="排序方式"
          >
            <el-option label="降序" value="desc"></el-option>
            <el-option label="升序" value="asc"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="搜索内容">
          <el-input
            v-model="formInline.queryValue"
            @change="queryClick"
            placeholder="关键词"
          ></el-input>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 0px 10px" v-if="storeGuid">
        <div style="padding: 10px; background-color: #ffffff">
          <el-button type="default" @click="exportClick"> 导出商品 </el-button>
          <el-button type="default" @click="batchSheetClick"> 批量盘点 </el-button>
          <el-button type="default" @click="batchUpdateSaleClick">
            批量修改促销
          </el-button>
        </div>
        <x-table
          ref="list"
          listApi="biz.warehouse.goods.info.list"
          paginationLayout="total, sizes, prev, next, jumper"
          actionFixed="right"
          emptyLabel="暂无库存信息"
          :defaultSort="defaultSort"
          :refreshList="false"
          :fieldList="fieldList"
          :actionList="actionList"
          :defaultParams="defaultParams"
          :actionWidth="120"
        >
          <template slot="row-info" slot-scope="scope">
            <warehouse-goods-info
              :goodsInfo="scope.row"
              :showConsume="true"
              :imageSize="80"
            >
              <template slot="info-append">
                <div
                  v-if="scope.row.effectiveDays < 180"
                  style="color: #919191; font-size: 14px; margin-top: 5px"
                >
                  <span> 效期天数: </span>
                  <span style="color: #f56c6c"> {{ scope.row.effectiveDays }}天 </span>
                </div>
                <div style="color: #919191; font-size: 14px; margin-top: 5px">
                  <span> 促销标签: </span>
                  <span v-if="scope.row.saleLabel" style="color: #f56c6c">
                    {{ scope.row.saleLabel }}
                  </span>
                  <el-select
                    style="width: 100px"
                    placeholder="促销标签"
                    @change="handleChangeSaleLabel($event, scope.row)"
                    size="mini"
                    :value="scope.row.saleLabel"
                  >
                    <el-option label="无" value=""></el-option>
                    <el-option label="临期1期" value="临期1期"> </el-option>
                    <el-option label="临期2期" value="临期2期"> </el-option>
                    <el-option label="临期3期" value="临期3期"> </el-option>
                    <el-option label="滞销1期" value="滞销1期"> </el-option>
                    <el-option label="滞销2期" value="滞销2期"> </el-option>
                    <el-option label="滞销3期" value="滞销3期"> </el-option>
                    <el-option label="积货1期" value="积货1期"> </el-option>
                    <el-option label="积货2期" value="积货2期"> </el-option>
                    <el-option label="积货3期" value="积货3期"> </el-option>
                  </el-select>
                  <span v-if="!!scope.row.saleLabel">
                    ({{
                      new Date(scope.row.saleLabelTime).format("YYYY-MM-dd hh:mm:ss")
                    }})
                  </span>
                  <span> 促销价： </span>
                  <el-input
                    type="number"
                    v-model="scope.row.salePrice"
                    @change="handleChangeSalePrice($event, scope.row)"
                    placeholder="促销单价"
                    style="width: 120px; margin-right: 8px"
                    size="mini"
                  ></el-input>
                </div>
              </template>
            </warehouse-goods-info>
          </template>
        </x-table>
      </div>
      <el-empty v-else description="请选择门店" :image-size="100"> </el-empty>
    </el-card>
  </div>
</template>

<script>
import detailPage from "./detail.vue";
import exportPage from "./__index_export.vue";
import batchSheetPage from "./__index_batch_sheet.vue";
import batchUpdateSalePage from "./__index_batch_update_sale.vue";
import customerStoreSelect from "../../../../components/business/customerStoreSelect.vue";
import warehouseGoodsInfo from "../../../../components/business/warehouseGoodsInfo.vue";

export default {
  components: {
    warehouseGoodsInfo,
    customerStoreSelect,
  },
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
    defaultParams() {
      return Object.assign(
        {
          storeGuid: this.storeGuid,
          categoryGuid: this.categoryGuid,
        },
        this.queryModel || {}
      );
    },
    defaultSort() {
      let orderBy = "";
      if (this.orderByField) {
        orderBy = `${this.orderByField} ${this.orderByDescOrAsc}`;
      }
      return orderBy;
    },
  },
  watch: {
    storeGuid() {
      this.commitState({ curStoreGuid: this.storeGuid });
    },
  },
  methods: {
    refresh() {
      if (this.$refs.list) {
        this.$refs.list.refresh();
      }
    },
    refreshDocment() {
      if (this.$refs.list) {
        this.$refs.list.refreshDocment();
      }
    },
    clearClick() {
      this.formInline = {
        minStock: "",
        maxStock: "",
        filterEffectiveDays: "",
        goodsType: "",
        optWarning: "",
        optStatus: "",
        queryValue: "",
      };
      this.categoryGuid = "";
      this.queryModel = {};
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
    exportClick() {
      this.$drawer.openDrawer(
        {
          title: "导出库存",
          refresh: this.refresh,
          component: exportPage,
          params: {
            storeGuid: this.storeGuid,
          },
        },
        true
      );
    },
    batchSheetClick() {
      this.$drawer.openDrawer(
        {
          title: "批量盘点",
          refresh: this.refresh,
          component: batchSheetPage,
          params: {
            storeGuid: this.storeGuid,
          },
        },
        true
      );
    },
    batchUpdateSaleClick() {
      this.$drawer.openDrawer(
        {
          title: "批量修改促销",
          refresh: this.refresh,
          component: batchUpdateSalePage,
          params: {
            storeGuid: this.storeGuid,
          },
        },
        true
      );
    },
    handleChangeSaleLabel(value, row) {
      this.requestApi(
        "biz.warehouse.goods.info.update",
        {
          guid: row.guid,
          storeGuid: row.storeGuid,
          saleLabel: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
    handleChangeSalePrice(value, row) {
      this.requestApi(
        "biz.warehouse.goods.info.update",
        {
          guid: row.guid,
          storeGuid: row.storeGuid,
          salePrice: value,
        },
        { showError: true }
      ).then(() => {
        this.refresh();
      });
    },
  },
  data() {
    return {
      storeGuid: "",
      categoryGuid: "",
      orderByField: "",
      orderByDescOrAsc: "desc",
      queryModel: {},
      formInline: {
        goodsType: "",
        minStock: "",
        maxStock: "",
        filterEffectiveDays: "",
        optWarning: "",
        optStatus: "",
        queryValue: "",
      },
      fieldList: [
        {
          label: "商品信息",
          minWidth: "320",
          slot: "info",
        },
      ],
      actionList: [
        {
          label: "详情",
          click: (row, tag, refresh) => {
            this.$drawer.openDrawer({
              title: "商品库存信息",
              refresh,
              component: detailPage,
              params: {
                guid: row.guid,
                storeGuid: row.storeGuid,
              },
            });
          },
        },
        {
          label: "同步到渠道",
          click: (row, tag, refresh) => {
            this.$confirm(`确定同步库存到渠道?`, "提示", {
              type: "warning",
            }).then(() => {
              this.requestApi(
                "biz.warehouse.goods.info.syncStock",
                {
                  guid: row.guid,
                  storeGuid: row.storeGuid,
                },
                {
                  showError: true,
                }
              ).then(() => {
                this.success("同步成功");
                refresh && refresh();
              });
            });
          },
        },
      ],
    };
  },
  mounted() {
    this.storeGuid = this.readState("curStoreGuid", "");
    this.onWatchState("storeCartData", this.refreshDocment);
  },
  destroyed() {
    this.offWatchState("storeCartData", this.refreshDocment);
  },
};
</script>
